import React, { useEffect, useState } from 'react';
import useTemplates, {
    Template,
    templateTypeLabels,
} from '../hooks/useTemplates';
import { Button } from '@/src/shadComponents/ui/button';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@/src/shadComponents/ui/table';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Loading from '@/src/Common/components/Loading';
import moment from 'moment-timezone';
import { Badge } from '@/src/shadComponents/ui/badge';
import PageShell from '@/src/Common/components/PageShell';

export default function TemplateList() {
    const [templates, setTemplates] = useState<Template[]>([]);
    const { listTemplates, isLoading, error } = useTemplates();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTemplates = async () => {
            const data = await listTemplates();
            setTemplates(data);
        };

        fetchTemplates();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (error) {
        return (
            <div className="rounded-md bg-red-50 p-4 mt-4">
                <div className="text-sm text-red-700">{error}</div>
            </div>
        );
    }

    if (isLoading) {
        return <Loading isLoading={true} />;
    }

    const actions = (
        <Button
            onClick={() => navigate('/admin/templates/new')}
        >
            <Plus className="size-4" />
            New Template
        </Button>
    );

    return (
        <PageShell
            title="Templates"
            subtitle="Manage your experience and processing templates"
            breadcrumbs={[{ label: 'Admin', href: '/admin/templates' }, { label: 'Templates' }]}
            actions={actions}
        >
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Name</TableHead>
                            <TableHead>Type</TableHead>
                            <TableHead>Version</TableHead>
                            <TableHead>Created</TableHead>
                            <TableHead>Updated</TableHead>
                            <TableHead className="text-right">
                                Actions
                            </TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {templates.map((template) => (
                            <TableRow key={template.id}>
                                <TableCell className="font-medium">
                                    {template.name}
                                </TableCell>
                                <TableCell>
                                    <Badge
                                        variant={
                                            template.templateType === 1
                                                ? 'default'
                                                : 'secondary'
                                        }
                                    >
                                        {
                                            templateTypeLabels[
                                                template.templateType
                                            ]
                                        }
                                    </Badge>
                                </TableCell>
                                <TableCell>{template.version}</TableCell>
                                <TableCell>
                                    {moment(template.createdAt).format(
                                        'MM/DD/YYYY',
                                    )}
                                </TableCell>
                                <TableCell>
                                    {moment(template.updatedAt).format(
                                        'MM/DD/YYYY',
                                    )}
                                </TableCell>
                                <TableCell className="text-right">
                                    <Button
                                        variant="outline"
                                        onClick={() =>
                                            navigate(
                                                `/admin/templates/${template.id}`,
                                            )
                                        }
                                    >
                                        View
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
        </PageShell>
    );
}
